import type { SpecParameter } from '@shared/spec';
import type { Parameter } from '@shared/types';

/**
 * Convert SpecParameter[] (from a DesignSpec) to artifact-level Parameter[]
 * (used by the parameter editor UI). Pure function — drops `expression`,
 * passes everything else through 1:1.
 *
 * Used at intake submission to seed the first artifact's `parameters` array
 * so the parameter editor isn't empty before the first agent render.
 */
export function specParametersToArtifactParameters(
  specParams: readonly SpecParameter[],
): Parameter[] {
  return specParams.map((p) => {
    const out: Parameter = {
      name: p.name,
      displayName: p.displayName,
      value: p.value,
      defaultValue: p.defaultValue,
    };
    if (p.type !== undefined) out.type = p.type;
    if (p.description !== undefined) out.description = p.description;
    if (p.group !== undefined) out.group = p.group;
    if (p.range !== undefined) out.range = p.range;
    return out;
  });
}
